import { Link } from "react-router-dom";
import {
  HelpCircle, PlayCircle, Mic, Camera, ClipboardCheck, BarChart3, ShieldCheck, Mail, ChevronRight,
} from "lucide-react";
import { Button } from "../components/ui/button";
import { resetTutorial } from "../components/OnboardingTour";

const FAQ = [
  {
    icon: PlayCircle,
    title: "Démarrer un audit",
    body: "Depuis 'Audits Terrain', sélectionnez un site puis une campagne active. L'audit s'ouvre en navigation question par question : répondez, notez un constat, et passez à la question suivante.",
  },
  {
    icon: Mic,
    title: "Dictée vocale",
    body: "Sur chaque question, appuyez sur le micro pour dicter votre constat au lieu de le taper. Fonctionne directement dans le navigateur (Web Speech API), sans connexion nécessaire une fois la page chargée.",
  },
  {
    icon: Camera,
    title: "Photos & preuves",
    body: "Ajoutez une photo depuis l'appareil photo ou la galerie pour justifier un score. Les photos sont stockées de façon sécurisée dans Google Drive, classées par site et par audit.",
  },
  {
    icon: ClipboardCheck,
    title: "Mode 'À revoir' & actions correctives",
    body: "Marquez une question 'À revoir' si un doute persiste. Pour toute non-conformité, créez une action corrective avec responsable et échéance depuis la question concernée ou l'onglet 'Plan d'Actions'.",
  },
  {
    icon: BarChart3,
    title: "Dashboards, Heatmap & Historique",
    body: "'Analyses & Heatmap' donne la vue nationale multi-sites. 'Historique 2024-2026' permet de comparer vos résultats à l'auto-évaluation 2024 et de suivre les actions issues de cette période.",
  },
];

export default function Aide() {
  return (
    <div className="p-4 sm:p-6 max-w-3xl mx-auto space-y-6" data-testid="aide-page">
      <div className="flex items-center gap-3">
        <div className="p-2.5 rounded-xl bg-emerald-100 dark:bg-emerald-900/30">
          <HelpCircle className="h-6 w-6 text-emerald-600 dark:text-emerald-400" />
        </div>
        <div>
          <h1 className="font-heading text-2xl sm:text-3xl font-black uppercase tracking-tight">Aide &amp; Guide</h1>
          <p className="text-sm text-muted-foreground">Tout ce qu'il faut savoir pour utiliser World Class EI</p>
        </div>
      </div>

      <Button
        data-testid="replay-tutorial-button"
        onClick={resetTutorial}
        variant="outline"
        className="gap-2"
      >
        <PlayCircle className="h-4 w-4" /> Revoir le tutoriel interactif
      </Button>

      <div className="space-y-3">
        {FAQ.map((item, i) => (
          <div key={i} data-testid={`aide-faq-item-${i}`} className="rounded-xl border border-border bg-card p-4 flex gap-3">
            <item.icon className="h-5 w-5 text-emerald-600 dark:text-emerald-400 shrink-0 mt-0.5" />
            <div>
              <h3 className="font-semibold text-sm">{item.title}</h3>
              <p className="text-sm text-muted-foreground mt-1 leading-relaxed">{item.body}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="rounded-xl border border-border bg-card p-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <ShieldCheck className="h-5 w-5 text-emerald-600 dark:text-emerald-400" />
          <div>
            <h3 className="font-semibold text-sm">Confidentialité &amp; RGPD</h3>
            <p className="text-xs text-muted-foreground">Comment vos données sont collectées et protégées</p>
          </div>
        </div>
        <Link to="/confidentialite" data-testid="aide-privacy-link" className="text-emerald-600 dark:text-emerald-400 flex items-center gap-1 text-sm font-medium">
          Consulter <ChevronRight className="h-4 w-4" />
        </Link>
      </div>

      <div className="rounded-xl border border-border bg-card p-4 flex items-center gap-3">
        <Mail className="h-5 w-5 text-emerald-600 dark:text-emerald-400" />
        <div>
          <h3 className="font-semibold text-sm">Besoin d'aide supplémentaire ?</h3>
          <p className="text-xs text-muted-foreground">Contactez la Direction Santé &amp; Sécurité Lafarge Ciments France.</p>
        </div>
      </div>
    </div>
  );
}
